import React from 'react';
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import LocalFireDepartmentOutlinedIcon from '@mui/icons-material/LocalFireDepartmentOutlined';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';

export const COLOURS = {
  primary: '#000000',
  secondary: '#545454',
  background: '#ffffff',
  border: 'rgba(0, 0, 0, 0.23)',
  borderLight: 'rgba(0, 0, 0, 0.08)',
  borderMedium: 'rgba(0, 0, 0, 0.12)',
  scrollButtonDisabled: '#9e9e9e'
} as const;

export const CARD_STYLES = {
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.2), 0px 0px 1px rgba(0, 0, 0, 0.24)'
} as const;

// Icon mapping for different duty types
export const DUTY_ICONS: Record<string, React.ComponentType<{ sx?: any }>> = {
  'key_holder': VpnKeyOutlinedIcon,
  'first_aider': MedicalServicesOutlinedIcon,
  'fire_warden': LocalFireDepartmentOutlinedIcon,
  'health_and_safety': HealthAndSafetyOutlinedIcon,
  'mental_health_first_aider': MedicalServicesIcon,
};
